module.exports = __webpack_public_path__ + "assets/img/z6.1af51397.png";